import {Component, Event, EventEmitter, h, Host, Listen, Prop, State, Watch} from "@stencil/core";

import {fileNameFromHeader, saveAs} from "../common/filesaver";

import {ConfirmationsPayload} from "./confirmations/confirmations";
import {Actions, getPossibleActions, MetaData, UserDecisions} from "../domain/app-logic";
import {_debug} from "../common/debugger/debugger";
import {logoutDownloadAccess} from "../utils/logout.utils";

export interface FeedbackParams {
  issue: string;
  region: string;
}

@Component({
  tag: "lb-antrag",
  styleUrl: "./styles.scss",
  shadow: true,
})

export class LBAntrag {
  @Prop() baseurl;

  @Prop() initialData;
  @Prop({mutable: true}) appConfig;
  @Prop({mutable: true}) definitionurl; // rest endpoint, where the form should be submitted to
  @Prop() submitEndpoint; // rest endpoint, where the form should be submitted to
  @Prop() features;
  @Prop() userDecisions: UserDecisions;
  @Prop() metaData: MetaData;
  @Prop({mutable: true}) userData: any;
  @Prop() endpoints;
  @Prop({mutable: true}) actions: Actions;
  @Prop() dse;

  @Prop() state;
  @Prop() authNotMatched;

  @Event() lb_loggedout: EventEmitter<any>;
  @Event() logout_required: EventEmitter<any>;
  @Event() form_submitted: EventEmitter<any>;
  @Event() not_beantragbar: EventEmitter<any>;

  userInfoComponent;

  @Prop() uuid;
  myId = Math.floor(Math.random() * 10000);

  constructor() {
    _debug("lb-antrag.constructor() uui", this.uuid);
    _debug("lb-antrag.constructor() myID", this.myId);
  }

  disconnectedCallback() {
    _debug("lb-antrag.constructor() uui", this.uuid);
    _debug("lb-antrag.constructor() myID", this.myId);
  }

  connectedCallback() {
    _debug("lb-antrag.constructor() uui", this.uuid);
    _debug("lb-antrag.constructor() myID", this.myId);
  }

  componentWillRender() {
    _debug("lb-antrag.constructor() uui", this.uuid);
    _debug("lb-antrag.constructor() myID", this.myId);
  }

  componentDidRender() {
    _debug("lb-antrag.constructor() uui", this.uuid);
    _debug("lb-antrag.constructor() myID", this.myId);
  }

  @State() success;

  @Watch('initialData')
  getFormdefinition() {
    if (this.initialData && this.initialData.api) {
      if (this.initialData.api.formular) {
        this.definitionurl = this.baseurl + this.initialData.api.formular;
      }
    }
  }

  // FIXME: handle new event from k-account
  @Listen('account_terminationdialogdismissed', {target: 'document'})
  onSessionTerminationDialogDismissed() {
    this.loggedOut = true;
    location.reload();
  }

  @Listen('disableLeavePageDialogEventEmitter', {target: 'document'})
  onDisableLeavePageDialogEvent() {
    this.disableLeavePageDialog = true;
  }

  componentDidLoad() {
    _debug('lb-antrag.componentDidLoad() entered uuid', this.uuid)
    _debug('lb-antrag.componentDidLoad() entered myID', this.myId)

    this.getFormdefinition();

    // as attribute/property of this component an "index" is given, pointing to the initial endpoint
    document.addEventListener("lb_loggedout", (ev: CustomEvent) => {
      _debug('componentDidLoad()::lb_loggedout triggered: ev:', ev)
      _debug('componentDidLoad()::lb_loggedout triggered: this.state:', this.state)
      _debug('componentDidLoad()::lb_loggedout triggered this.success:', this.success)
      _debug('componentDidLoad()::lb_loggedout triggered this.formrendererInitiated:', this.formrendererInitiated)

      if (ev.detail?.reload === false) {
        return;
      }

      this.userData = null;
      // if user not in "Zwischengespeicherte Anträge" && formrenderer already initiated
      if (this.formrendererInitiated && !this.success) {
        console.info("componentDidLoad()::lb_loggedout hard location.reload() to reset form-renderer")
        // if we already initiated a form renderer instance with user data, we need to reload the page
        // because we cannot reset the formrenderer properly
        this.loggedOut = true;
        location.reload();
      }
    });

    document.addEventListener("account_loggedout", (ev: CustomEvent) => {
      _debug('componentDidLoad()::account_loggedout triggered: ev:', ev)
      _debug('this.state:', this.state)
      _debug('this.success:', this.success)

      if (this.success && !this.loggedOut) {
        logoutDownloadAccess(this.baseurl + this.actions?.logoutDocumentAccess?.href).then(status => {
          _debug('logoutDownloadAccess status:', status);
          this.userData = null;
          this.loggedOut = true;
          window.location.reload();
        });
      } else {
        _debug('account_loggedout for !success...');
        this.userData = null;
        this.loggedOut = true;
        window.location.reload();
      }
    });

    if (document.querySelector("lb-user-info")) {
      this.userInfoComponent = document.querySelector("lb-user-info");
      if (this.userInfoComponent) {
        this.userInfoComponent.requireConfirmation = true;
      }
    } else {
      document.addEventListener("lb_userinfoinitiated", () => {
        this.userInfoComponent = document.querySelector("lb-user-info");
        if (this.userInfoComponent) {
          this.userInfoComponent.requireConfirmation = true;
        }
      });
    }
  }

  // save state and data from form renderer
  // ToDo: wrap form-renderer, confirmations and success in one component

  @State() formValid;
  @State() isSummaryPage;
  @State() ageInfo;
  @State() formHasOptionalData;
  @State() formData; // formData given from outside, e.g. load saved
  @State() currentFormData; // formData from current state in renderer
  @State() currentFormDataTidy; // formData *without userdata* from current state in renderer
  @State() documentIDs; // formData *without userdata* from current state in renderer
  @State() anlagenVerzeichnis;
  @State() pageInfos;
  @State() dsemodal;

  // Listen to form renderer events
  @Listen("pagechanged") handleFormPageChange(evt) {
    const pageinfos = evt.detail;
    _debug("pagechanged in lb-antrag");
    _debug(pageinfos);
    if (pageinfos.pageInfos) {
      this.pageInfos = pageinfos.pageInfos;
    }
    if (pageinfos.currentPage) {
      this.isSummaryPage = pageinfos.currentPage.isSummary;
    }
  }

  @Listen("formrendererinitiated") handleFormInit(ev) {
    this.formrendererInitiated = true;
    _debug("options in listener:");
    _debug(ev.detail);
    this.rendererOptions = ev.detail;
    _debug("set data in initiated listener:");
    _debug(this.initialData);
    if (this.initialData?.entwurf?.antragsdaten) {
      const {payload, ...confirmations} = this.initialData.entwurf.antragsdaten;
      this.confirmations = confirmations;
      if (payload) {
        this.formData = payload;
      }
    }
  }

  @Listen("ageinfo") handleAgeInfoGiven(ev) {
    this.ageInfo = ev.detail;
  }

  @Listen("optionalDataGiven") handleOptionalDataGiven(ev) {
    this.formHasOptionalData = ev.detail === true;
  }

  @Listen("formValidated") handleFormValidated(ev) {
    this.formValid = ev.detail;
  }

  @Listen("filesUploaded", {target: 'document'}) handleFilesUploaded(ev) {
    this.documentIDs = ev.detail;
  }

  @Listen("dataUpdate") handleDataUpdate(ev) {
    this.currentFormData = ev.detail;
    _debug("listen to data update:");
    _debug(this.currentFormData);
  }

  @Listen("tidyDataUpdate") handleTidyDataUpdate(ev) {
    this.currentFormDataTidy = ev.detail;
  }

  @Listen("anlagenVerzeichnis") handleAnlagenVerzeichnisGiven(ev) {
    this.anlagenVerzeichnis = ev.detail;
  }

  // as soon as a formdefinition is available, wie initiate the form renderer

  @Prop({reflect: true, mutable: true}) rendererOptions;

  formrendererInitiated = false;
  formRenderer;

  @Prop({mutable: true}) entwurf;

  @Prop({mutable: true}) i18n;
  @Prop({reflect: true}) language: string = "de";

  @State() finalizedForm;

  @State() confirmations: ConfirmationsPayload;
  @State() confirmationsValidated: boolean;

  handleNewActions(actions: Actions) {
    this.submitEndpoint = actions.submitOnline;
    _debug('actions in handleNewActions lb-fe:', actions)
    _debug('submitEndpoint in handleNewActions lb-fe:', this.submitEndpoint)
  }

  @Watch("confirmationsValidated")
  confirmationsGiven() {
    _debug("confirmationsGiven() confirmationsValidated changed");
    if (this.confirmationsValidated) {
      const formdata = this.currentFormData;
      const userDecisions = {
        nutzerKontenTyp: this.userDecisions?.accountType,
        language: this.userDecisions?.language
      };
      const data = {payload: formdata, userDecisions: userDecisions, ...this.confirmations};
      _debug("confirmationsGiven() validated, submitting data:", data);
      this.submit(data);
    }
  }

  @State() submitData;
  @State() busy;

  submit(data) {
    if (!this.actions?.submitOnline && !this.actions?.submitOffline && !this.actions?.retrySubmitOnline) {
      console.warn("actions.submitOnline or actions.submitOffline must be present");
      return;
    }

    this.submitData = JSON.stringify(data);

    if (this.actions && this.actions.submitOffline && this.userDecisions.offline) {
      this.successMessage = {formTitle: this.metaData.title};
      this.error = null;
      this.success = true;
      return;
    }

    this.error = null;
    this.busy = true;
    _debug("before fetching, this.offlineversand",
      this.userDecisions?.offline ? "is offlineversand" : "is not offlineversand");
    _debug("payload data:", typeof data);
    _debug("payload jsonstring", this.submitData);

    fetch(this.baseurl + this.submitEndpoint.href, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": "true",
        Prefer: "example=bundesadler", // antrag-erstellt, leistung-offline, retry
        //        'Content-Type':'application/x-www-form-urlencoded'
      },
      body: this.submitData, // body data type must match "Content-Type" header
    }).then((resp) => {
      if (resp.ok) {
        _debug("submit response is ok");
        if (this.userDecisions.offline) {
          _debug("offline submit response code:", resp.status);
          resp.blob().then((blob) => {
            saveAs(blob, fileNameFromHeader(resp.headers.get("content-disposition"), "Antrag.pdf"));
            this.busy = false;
          });
        } else {
          resp["json"]().then((result) => {
            _debug("online submit response code:", resp.status);
            if (resp.status === 200) { // TODO what is the alternative? it is already ok, BE doesn't send different 200 codes
              this.successMessage = result;
              _debug("online submit success response", this.successMessage);
              this.actions = getPossibleActions(result);

              if (this.successMessage.formularState === "notBeantragbar") {
                _debug("online submit success error response: notBeantragbar");
                this.not_beantragbar.emit();
              } else if (this.actions.retrySubmitOnline) { // TODO: same as 'notBeantragbar'. remove
                _debug("online submit success error response: retrySubmitOnline");
                this.submitEndpoint = this.actions.retrySubmitOnline;
                this.error = ({
                  error: this.i18n?.meta?.[this.language]?.error?.retrySubmitText,
                  timestamp: new Date().toISOString(),
                  traceId: result.traceId || "n/a",
                });
              } else if (!this.actions.downloadAntrag) {
                _debug("online submit success error response: downloadAntrag missing");
                this.error = ({
                  error: this.i18n?.meta?.[this.language]?.error?.retryAgainText,
                  timestamp: new Date().toISOString(),
                  traceId: result.traceId || "n/a",
                });
              } else {
                _debug("online submit success continuing to success page");
                this.form_submitted.emit();
                this.success = true;
              }
              this.busy = false;
            }
          });
        }
      } else {
        if (resp.status === 408 || resp.status === 504) {
          this.error = ({
            error: this.i18n?.meta?.[this.language]?.error?.timeoutText,
            timestamp: new Date().toISOString(),
            traceId: "n/a",
          });
        } else {
          resp.json().then((result) => {
            this.error = result;
          }).catch((err) => {
            console.error('failed to send "Antrag"', resp, err);
            this.error = ({
              error: `${resp.status} - ${this.i18n?.meta?.[this.language]?.error?.retryAgainText}`,
              timestamp: new Date().toISOString(),
              traceId: "n/a",
            });
          });
        }
        this.busy = false;
        this.confirmationsValidated = false;
      }
    });
  }

  successMessage;

  @State() error;

  isBirthdayFieldAvailable() {
    return this.ageInfo ? this.ageInfo.hasBirthdate : false;
  }

  loggedOut;
  uploadsExpired;
  disableLeavePageDialog;

  @State() pristine = true;

  // this is deprecated. Will be replaced with a proper navigation handling
  @Watch("pristine")
  onFormFilled() {
    window.onbeforeunload = (event) => {
      let shouldWeBlock : boolean = !(this.state === "preview" ||
        this.state === "offlineDecision" ||
        this.loggedOut ||
        this.disableLeavePageDialog ||
        this.uploadsExpired ||
        this.authNotMatched ||
        this.success
    )
      if (shouldWeBlock) {
        event.preventDefault();
        return shouldWeBlock;
      }
      return;
    };
  }

  @Listen("datachanged")
  onSomethingChanged() {
    this.pristine = false;
  }

  getFeedbackParams() {
    if (this.metaData.leistungsschluessel && this.metaData.ars) {
      return {
        issue: this.metaData.leistungsschluessel,
        region: this.metaData.ars?.padEnd(12, '0')
      } as FeedbackParams;
    }

    return null;
  }

  render() {
    return (
      <Host>
        {_debug("lb-antrag.render() success:", this.success)}
        {_debug("lb-antrag.render() uuids", this.uuid)}
        {_debug("lb-antrag.render() myId", this.uuid)}
        {!this.success &&
          <div>
            <fert-form-renderer
              definitionurl={this.definitionurl}
              data={this.formData}
              userdata={this.userData}
              metadata={this.metaData}
              userdecisions={this.userDecisions}
              uploadendpoint={this.endpoints.fileUpload}
              catalogendpoint={this.initialData.api?.["catalog"]}
              i18n={this.i18n?.formular}>
              <slot/>
            </fert-form-renderer>

            <form-paging direction="prev" data-testid="prev-button"
                         i18n={this.i18n?.meta?.[this.language].navigation}></form-paging>
            <form-paging direction="next" data-testid="next-button"
                         i18n={this.i18n?.meta?.[this.language].navigation}></form-paging>

            {this.isSummaryPage && !this.success && (
              <lb-confirmations
                ageInfo={this.ageInfo}
                formValid={this.formValid}
                formHasOptionalData={this.formHasOptionalData}
                metadata={this.metaData}
                userdata={this.userData}
                userdecisions={this.userDecisions}
                onConfirmationsvalidated={({detail}) => {
                  this.confirmationsValidated = true;
                  this.confirmations = detail;
                }}
                onConfirmationschanged={({detail}) => {
                  this.confirmations = detail;
                }}
                data={this.confirmations}
                i18n={this.i18n}
                language={this.language}
                attachmentIndex={this.anlagenVerzeichnis}
                appConfig={this.appConfig}
              ></lb-confirmations>
            )}

            {(this.actions?.save || this.actions?.saveUpdate) && this.state === 'ready' && (
              <lb-tmp-save
                dse={this.dse}
                baseurl={this.baseurl}
                saveEndpoint={this.actions.save}
                initialData={this.entwurf}
                updateEndpoint={this.actions.saveUpdate}
                formId={this.initialData.metadata.id}
                leistungsschluessel={this.initialData.metadata.leistungsschluessel}
                mandant={this.initialData.metadata.mandant}
                ars={this.initialData.metadata.ars}
                formdata={this.currentFormDataTidy}
                documentids={this.documentIDs}
                confirmations={this.confirmations}
                userDecisions={this.userDecisions}
                onNewActions={(ev) => this.handleNewActions(ev.detail)}
                i18n={this.i18n?.meta?.[this.language]}
              ></lb-tmp-save>
            )}
          </div>
        }


        <aside>
          {!this.success && (
            <lb-form-navigation
              aria-hidden="true"
              pageInfos={this.pageInfos}
              i18n={this.i18n?.meta?.[this.language]?.navigation}
            />
          )}

          {this.dse && (
            <div class="dse-link" data-testid="dse-area">
              <h5>{this.i18n?.meta?.[this.language]?.beantragung?.dseHeadline}</h5>
              <a onClick={(evt) => {
                evt.preventDefault();
                this.dsemodal = true
              }} href="#!" tabindex="0">
                {this.i18n?.meta?.[this.language]?.beantragung?.dseBtnLabel}
              </a>
            </div>
          )}
        </aside>


        {this.success && (
          <lb-form-success
            successMessage={this.successMessage}
            data={this.submitData}
            downloadUrl={this.baseurl + this.actions.downloadAntrag?.href}
            generatePdfEndpoint={this.baseurl + this.actions?.submitOffline?.href}
            i18n={this.i18n?.meta?.[this.language]}
            language={this.language}
            offline={this.userDecisions.offline}
            appConfig={this.appConfig}
            feedbackParams={this.initialData.metadata.feedback ? this.getFeedbackParams() : null}
          />
        )}

        <c-modal
          visible={this.error?.error?.length > 0}
          flash
          containerstyle="error"
          onClose={() => (this.error = null)}
        >
          <lb-errorview
            slot="content"
            i18n={this.i18n}
            language={this.language}
            error={this.error}
          />
        </c-modal>

        {
          this.dsemodal &&
          <muse-dialog open dismissable onDismiss={() => (this.dsemodal = false)}>
            <c-markdown-renderer>
              <div slot="source">{this.dse}</div>
            </c-markdown-renderer>
          </muse-dialog>
        }

        <c-modal visible={this.busy}>
          <c-container slot="content" full-width full-height inactive>
            <c-icon name="spinner"></c-icon>
          </c-container>
        </c-modal>

        <lb-uploads
          sessionexpiry={1800000}
          onUploadsexpired={() => this.uploadsExpired = true}
          i18n={this.i18n?.meta?.[this.language].session}
          showexpiryinfos={!this.userData}
          refreshurl={this.actions?.documentsRefresh?.href}/>
      </Host>
    );
  }
}
